module.exports = __webpack_public_path__ + "static/media/C5833D98-BD33-4D8D-99B7-B1810D9076E8-min.4bcc6788.jpg";